<template>
  <v-menu
    v-model="menuOpen"
    :close-on-content-click="false"
    offset-y
    nudge-bottom="4"
    max-height="360"
    min-width="220"
    max-width="300"
  >
    <template v-slot:activator="{ on, attrs }">
      <span
        class="column-filter-trigger d-inline-flex align-center text-no-wrap"
      >
        <span class="text-caption font-weight-bold">{{ label }}</span>
        <v-btn v-bind="attrs" v-on="on" icon x-small class="ml-1" @click.stop>
          <v-icon small :color="hasSelection ? 'secondary' : 'grey darken-1'">
            {{ hasSelection ? 'mdi-filter' : 'mdi-menu-down' }}
          </v-icon>
        </v-btn>
      </span>
    </template>

    <v-card>
      <v-card-text class="pa-2">
        <v-text-field
          v-model="search"
          dense
          outlined
          hide-details
          clearable
          placeholder="Search..."
          prepend-inner-icon="mdi-magnify"
          class="mb-2"
          autofocus
          @keydown.stop
        ></v-text-field>

        <div class="d-flex justify-space-between mb-1">
          <v-btn x-small text @click="selectAll"> All </v-btn>
          <v-btn x-small text @click="selectNone"> None </v-btn>
        </div>

        <v-divider></v-divider>

        <v-list dense class="filter-options-list pa-0">
          <v-list-item
            v-for="option in filteredOptions"
            :key="option"
            @click="toggle(option)"
          >
            <v-list-item-action class="mr-2 my-0">
              <v-simple-checkbox
                :value="isSelected(option)"
                @input="toggle(option)"
                dense
                color="secondary"
              ></v-simple-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="text-body-2">
                {{ option }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="filteredOptions.length === 0">
            <v-list-item-content>
              <v-list-item-title class="text-caption grey--text text-center">
                No matches
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    label: { type: String, required: true },
    options: { type: Array, default: () => [] },
    value: { type: Array, default: () => [] },
  },
  data: () => ({
    menuOpen: false,
    search: '',
  }),
  computed: {
    hasSelection() {
      return this.value.length > 0
    },
    filteredOptions() {
      if (!this.search) return this.options
      const q = this.search.toLowerCase()
      return this.options.filter((o) => o.toLowerCase().includes(q))
    },
  },
  watch: {
    menuOpen(open) {
      if (open) {
        this.search = ''
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
  },
  beforeDestroy() {
    document.body.style.overflow = ''
  },
  methods: {
    isSelected(option) {
      return this.value.includes(option)
    },
    toggle(option) {
      const selected = [...this.value]
      const idx = selected.indexOf(option)
      if (idx >= 0) {
        selected.splice(idx, 1)
      } else {
        selected.push(option)
      }
      this.$emit('input', selected)
    },
    selectAll() {
      this.$emit('input', [...this.filteredOptions])
    },
    selectNone() {
      this.$emit('input', [])
    },
  },
}
</script>

<style scoped>
.filter-options-list {
  max-height: 240px;
  overflow-y: auto;
}
</style>
